import { AbgSxProps } from '@abg/typings';

export const SnackBarStyles: AbgSxProps = {
  maxWidth: '402px',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.1)',
};
